import React, { useContext } from "react";
import { Button } from "@mui/material";
import { DynamicComponentProps } from "../../core/_models";

interface ButtonComponentProps extends DynamicComponentProps {
  values?: any;
  className?: string;
  variant?: "text" | "outlined" | "contained";
  color?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
  isSubmit?: boolean;
}

export function ButtonComponent({
                                  config,
                                  context,
                                  values,
                                  className = "",
                                  variant = "contained",
                                  color = "primary",
                                  isSubmit = false
                                }: ButtonComponentProps) {
  const { hint, text, action } = config;

  const formContext = useContext(context);

  const buttonAction = (e: any) => {
    if (action != null) {
      formContext.submit({ action, values });
    }
  };

  if (isSubmit) {
    return (
      <Button
        type={"submit"}
        variant={variant}
        className={`mr-4 ${className}`}
        color={color}
        title={hint}
      >
        {text}
      </Button>
    );
  }

  return (
    <Button
      type={"button"}
      variant={variant}
      className={`mr-4 ${className}`}
      color={color}
      title={hint}
      onClick={buttonAction}
    >
      {text}
    </Button>
  );
}